import { Attribute } from '../../types';
import { ValidUnit } from '../../constants/units';

export const getUnitFromAttributes = (attributes: Attribute[], key: string): string =>
    attributes.find((a) => a.key === key)?.unit ?? ValidUnit.KILOMETERS;
